import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import ReactLoading from 'react-loading'

import { Dropdown, Menu, Input } from 'antd'
import classNames from 'classnames'

import { useAppSelector, useAppDispatch } from '_src/store/hooks'

import {
  setSwapVisible,
  setSwapNetworkId,
  setFromData,
  setToData,
  setFromInput,
  setConvert,
} from '_src/store/swap/reducer'

import Icon from '_src/components/Icon'
import Modal from '_src/components/Modal'
import Button from '_src/components/Button'

import { isMainCurrency } from '_src/contracts/common'
import { wrappedTokenTransferFrom } from '_src/contracts/wrappedToken'

import { getChainBlockChainBrowserUrl } from '_src/utils/chain/chainConfFunc'

import './index.less'

export const Wrap = ({ className, t, data, list, handleWrapClick }) => {
  const dispatch = useAppDispatch()

  const handleMenuClick = () => {
    handleWrapClick && handleWrapClick()
    dispatch(setSwapVisible(true))
    dispatch(setSwapNetworkId(list.chain_id))

    // data 就是 from 参数源

    // 组装 from 参数
    // const from = {
    //   type: 1,
    //   symbol: 'AAC',
    //   balance: 100,
    //   input: 0,
    // }

    const from = {
      symbol: data.symbol,
      balance: data.balance,
      contract_addr: data.contract_addr,
    }

    let to = ''

    dispatch(setFromData(from))
    // 组装 to 参数

    if (isMainCurrency(data.contract_addr)) {
      // to 就是 WAAC
      // const to = {
      //   type: 2,
      //   symbol: 'WAAC',
      //   balance: 20,
      // }

      const item = list?.currencies.find((c) => c.symbol == 'WAAC')

      if (item) {
        to = {
          symbol: item.symbol,
          balance: item.balance,
          contract_addr: item.contract_addr,
        }
      }
    } else {
      //  to 就是 AAC
      const item = list?.currencies.find((c) => isMainCurrency(c.contract_addr))
      if (item) {
        to = {
          symbol: item.symbol,
          balance: item.balance,
          contract_addr: item.contract_addr,
        }
      }
    }

    to && dispatch(setToData(to))
  }
  const menu = (
    <Menu
      onClick={handleMenuClick}
      items={[
        {
          label: t('convert.swap'),
          key: '1',
        },
      ]}
    />
  )
  return (
    <Dropdown overlay={menu} overlayClassName="inft-wrap-dropdown">
      <div className={classNames('inft-wrap-area', className)}>
        <Icon className="inft-wrap-ellipsis" type="icon-share-ellipsis" />
      </div>
    </Dropdown>
  )
}

const Convert = () => {
  const { t } = useTranslation()
  const { address, theme } = useAppSelector((store) => store.global)
  const { visible, networkId, from, to } = useAppSelector((store) => store.swap)

  const dispatch = useAppDispatch()

  let [rotate, setRotateimg] = useState(true)
  let [loading, setLoading] = useState(false)
  let [hash, setHash] = useState('')
  let [receiptLoading, setReceiptLoading] = useState(false)

  const handleGoBrowser = () => {
    if (networkId) {
      const url = `${getChainBlockChainBrowserUrl(networkId)}${hash}`
      window.open(url)
    }
  }

  const handleInputChange = (e) => {
    let count = ''
    const { value } = e.target

    if (/^(([1-9]{1}\d*)|(0{1}))((.\d{0,30})?)$/.test(value)) {
      if (value > from.balance) {
        count = from.balance
      } else {
        count = value
      }
    }

    dispatch(setFromInput(count))
  }

  const handleMax = () => {
    let count = from.balance

    if (isMainCurrency(from.contract_addr)) {
      if (Number(count) > 0.5) {
        count -= 0.5
      }
    }

    dispatch(setFromInput(count))
  }

  const handleTransform = () => {
    setRotateimg(!rotate)
    dispatch(setConvert())
  }

  const setTranHash = (hash) => {
    setHash(hash)
    setLoading(false)
    setReceiptLoading(true)
  }

  const handleClose = () => {
    dispatch(setSwapVisible(false))
    setLoading(false)
    setHash('')
    setReceiptLoading(false)
  }

  const handleSwap = async () => {
    setLoading(true)

    // 开始调合约
    const result = await wrappedTokenTransferFrom({ address, from, to, callback: setTranHash }).catch((error) => {
      console.log(error)
      setLoading(false)
    })

    if (result?.status) {
      setReceiptLoading(false)
    }
  }

  return (
    <Modal visible={visible} title={t('convert.convert_tokens')} handleClose={handleClose} width={780}>
      {!hash && (
        <div className="inft-convert-container">
          <div className="inft-convert-top">
            <div className="symbol-title"> {t('convert.swap')}</div>

            <div className="symbol-middle">
              <Input
                onChange={handleInputChange}
                value={from.input}
                className="symbol-input"
                placeholder={t('convert.please_enter')}
                bordered={false}
              />
              <div className="symbol-descript">
                <img className="symbol-logo" src="/static/img/chainLogo/chain-logo-aac.png" />
                <div className="symbol-text">{from.symbol}</div>
              </div>
            </div>

            <div className="symbol-balance">
              <div onClick={handleMax} className="balance-max cursor">
                {t('convert.max')}
              </div>
              <div className="balance-text">
                {t('convert.balance')}: {from.balance}
              </div>
            </div>
          </div>
          <div onClick={handleTransform} className={classNames('swap-transform', rotate ? 'rotate180' : 'rotate0')} />
          <div className="inft-convert-bottom">
            <div className="symbol-title"> {t('convert.for')}</div>

            <div className="symbol-middle">
              <div className="symbol-input-text">{from.input || 0}</div>
              <div className="symbol-descript">
                <img className="symbol-logo" src="/static/img/chainLogo/chain-logo-aac.png" />
                <div className="symbol-text">{to.symbol}</div>
              </div>
            </div>

            <div className="symbol-balance">
              <div className="balance-text">
                {t('convert.balance')}: {to.balance}
              </div>
            </div>
          </div>
          <div className="inft-convert-tip">
            <Icon type="icon-swap-tip" className="icon-swap-tip" />
            <div className="swap-tip-text">
              <Trans
                i18nKey="convert.convert_from_to"
                values={{
                  from: from.symbol,
                  to: to.symbol,
                }}
              />
            </div>
          </div>

          <div className="inft-convert-button-container">
            {loading ? (
              <div className="inft-convert-button-loading">
                <ReactLoading
                  type="spinningBubbles"
                  color={theme === 'dark' ? '#fff' : '#333'}
                  height={20}
                  width={20}
                />
                <div className="loading-text">{t('convert.confirm_wallet')}</div>
              </div>
            ) : (
              <Button disabled={!Number(from.input)} className="inft-convert-button" onClick={handleSwap}>
                <Trans
                  i18nKey="convert.swap_symbol"
                  values={{
                    symbol: to.symbol,
                  }}
                />
              </Button>
            )}
          </div>
        </div>
      )}

      {hash && (
        <div className="inft-convert-hash-container">
          {receiptLoading ? (
            <ReactLoading type="spinningBubbles" color={theme === 'dark' ? '#fff' : '#333'} height={80} width={80} />
          ) : (
            <Icon type="icon-swap-success" className="icon-swap-success" />
          )}
          <div className="inft-hash-text">
            {receiptLoading ? t('convert.swap_pending') : t('convert.swap_confirmed')}
          </div>
          <Button className="inft-button-hash" onClick={handleClose}>
            {t('convert.close')}
          </Button>
          <div className="inft-view-hash" onClick={handleGoBrowser}>
            {t('convert.view_hash')}
          </div>
        </div>
      )}
    </Modal>
  )
}

export default Convert
